import { CheckIcon, CloseIcon } from "@/assets/icons";
import { cn } from "@/lib/utils";

type DatasetDisplayNameMenuProps = {
  isDisabled: boolean;
  onCancelRenameClicked: () => void;
  onConfirmRenameClicked: () => void;
};

export const DatasetDisplayNameMenu = ({
  isDisabled,
  onCancelRenameClicked,
  onConfirmRenameClicked
}: DatasetDisplayNameMenuProps) => {
  return (
    <div className="flex items-center gap-1">
      <button type="button">
        <CloseIcon
          className={cn(
            "w-4 h-4",
            isDisabled
              ? ["fill-light-gray", "cursor-not-allowed"]
              : "fill-dim-gray"
          )}
          title="Cancel Rename Dataset Display Name"
          onClick={onCancelRenameClicked}
        />
      </button>
      <button type="button">
        <CheckIcon
          className={cn(
            "w-4 h-4",
            isDisabled
              ? ["fill-light-gray", "cursor-not-allowed"]
              : "fill-dim-gray"
          )}
          title="Confirm Rename Dataset Display Name"
          onClick={onConfirmRenameClicked}
        />
      </button>
    </div>
  );
};
